<script lang="ts" setup>
import type { ToasterProps } from 'vue-sonner'
import { Toaster as Sonner } from 'vue-sonner'

const props = defineProps<ToasterProps>()
const appConfig = useAppConfig()
</script>

<template>
  <Sonner
    class="toaster group"
    v-bind="props"
    :toast-options="{
      classes: {
        toast:
          'group toast group-[.toaster]:bg-white group-[.toaster]:text-[#09090b] group-[.toaster]:border-[#e4e4e7] group-[.toaster]:shadow-lg flex space-x-4',
        title: 'group-[.toast]:text-[#09090b] font-bold',
        description: 'group-[.toast]:text-[#71717a]',
        actionButton:
          'group-[.toast]:bg-[#e11d48] group-[.toast]:text-[#fff1f2]',
        cancelButton:
          'group-[.toast]:bg-[#f4f4f5] group-[.toast]:text-[#71717a]',
        closeButton:
          'group-[.toast]:bg-[#f4f4f5] group-[.toast]:text-[#71717a]',
      },
    }"
  >
    <template #success-icon>
      <UIcon
        :name="appConfig.ui.icons.success"
        class="size-6 text-green-700"
      />
    </template>
    <template #error-icon>
      <UIcon
        :name="appConfig.ui.icons.error"
        class="size-6 text-red-700"
      />
    </template>
    <template #info-icon>
      <UIcon
        :name="appConfig.ui.icons.info"
        class="size-6 text-blue-700"
      />
    </template>
    <template #warning-icon>
      <UIcon
        :name="appConfig.ui.icons.warning"
        class="size-6 text-yellow-600"
      />
    </template>
  </Sonner>
</template>
